import React, { useEffect, useState } from "react";
import { evaluacionesService } from "../../../../../_services/evaluaciones.service";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { fixNumber } from "../../../../../utils/utils";
import moment from "moment";
import { actuacionesService } from "../../../../../_services/actuaciones.service";
import { tipoEtapasService } from "../../../../../_services/tipoEtapas.service";

export const RealizarEvaluaciones = ({ abogados }) => {
  const [tipoEtapas, setTipoEtapas] = useState([]);
  const [fechas, setFechas] = useState({
    fecha_ini_eval: "",
    fecha_fin_eval: ""
  });
  const [loading, setLoading] = useState(false);
  const [compleados, setCompletados] = useState(0);

  useEffect(() => {
    const getData = async () => {
      let res = await tipoEtapasService.getAllTipoEtapas();
      setTipoEtapas(res);
    };
    getData();
  }, []);

  const RealizarEvaluacion = async (abogado) => {
    try {
      setLoading(true);

      const permitidosRes = await evaluacionesService.getEvaluacionesConfig();
      const permitido_sin_radicar = permitidosRes.find(e => e.categoria === "sin_radicar");
      const permitido_sin_archivar = permitidosRes.find(e => e.categoria === "sin_archivar");
      const permitido_faltantes = permitidosRes.find(e => e.categoria === "faltantes");

      const permitidosData = {
        sin_radicar: permitido_sin_radicar?.maximo,
        sin_archivar: permitido_sin_archivar?.maximo,
        faltantes: permitido_faltantes?.maximo,
      };

      // const actuacionesRes = await actuacionesService.actuacionesTrimestrales({ abogado: data?.codexterno });
      const actuacionesRes = await actuacionesService.actuacionesSearch({
        data: {
          abogado,
        },
        abogado,
        gruposId: [2, 3],
        desde: fechas.fecha_ini_eval,
        hasta: fechas.fecha_fin_eval
      }, "evaluacion");

      if (actuacionesRes?.length) {
        const filtered = actuacionesRes.filter((e) => {
          let situacion = "";

          const historicos = e?.imponibles?.map((e) => e?.historico).sort((a, b) => new Date(a?.fecha) - new Date(b?.fecha));
          if (historicos.length) {
            const historico = historicos[historicos.length - 1];

            if (historico?.SITUACION === "Gestión Legal" || historico?.SITUACION === "Título Ejecutivo") {
              situacion = new Date(historico?.fecha) >= new Date(fechas.fecha_ini_eval) && new Date(historico?.fecha) <= new Date(fechas.fecha_fin_eval);
            }
          }
          const actuaciones = e?.imponibles?.filter((imp) => imp?.actuaciones.filter((ac) => new Date(ac?.fecha) >= new Date(fechas.fecha_ini_eval) && new Date(ac?.fecha) <= new Date(fechas.fecha_fin_eval))?.length);

          return situacion || actuaciones?.length;
        });

        const causas = filtered.map((e) => {
          const actuaciones = e?.imponibles?.filter((imp) => imp?.actuaciones?.length);

          if (actuaciones?.length) {
            const imponibles = e?.imponibles.map((imp) => imp.actuaciones).flat().sort((a, b) => a?.id_etapa - b?.id_etapa);

            return imponibles?.length ? imponibles[imponibles.length - 1] : null;
          } else {
            const historicos = e?.imponibles?.sort((a, b) => new Date(a?.historico?.fecha) - new Date(b?.historico?.fecha));

            return historicos?.length ? historicos[historicos.length - 1] : null;
          }
        }).filter(e => e?.historico || e?.tipo_etapa?.evaluacion);

        const actuacionesData = causas;

        const apremios = causas.filter((e) => {
          if (e.historico) {
            return e.historico?.SITUACION === "Título Ejecutivo";
          }
          else {
            return e?.tipo_etapa?.grupo === 3;
          }
        });

        const extrajudiciales = causas.filter((e) => {
          if (e.historico) {
            return e.historico?.SITUACION === "Gestión Legal";
          }
          else {
            return e?.tipo_etapa?.grupo === 2;
          }
        });

        const sin_radicar = causas.filter(e => {
          if (e.historico?.SITUACION === "Gestión Legal") {
            let tipo = tipoEtapas.find((e) => e.nombre === "Plazo máximo para iniciar el apremio");

            const b = new Date().getTime() > new Date(moment(e.historico.fecha).add(tipo?.tiempo, tipo?.tipo_tiempo).format("YYYY-MM-DD")).getTime();

            return b;
          } else {
            const fecha_limite = moment(e.fecha).add("day", 90).format("YYYY-MM-DD");

            const b = new Date().getTime() > new Date(fecha_limite).getTime();
            return e?.tipo_etapa?.grupo === 2 && b;
          }
        });

        const activos = apremios.filter(e => e?.tipo_etapa?.estado?.toLowerCase() === "activo");
        // const archivados = apremios.filter(e => e.tipo_etapa.estado?.toLowerCase() === "archivado");

        const sin_movimientos = activos.filter(e => {
          const b = new Date().getTime() > new Date(moment(e.fecha).add(e?.tipo_etapa?.tiempo, e?.tipo_etapa?.tipo_tiempo).format("YYYY-MM-DD")).getTime();
          return b;
        });

        const actuaciones = {
          total: causas?.length,
          sin_radicar: extrajudiciales?.length,
          apremios: apremios?.length,
          sin_movimientos: sin_movimientos?.length,
          sin_archivar: activos?.length,
        };

        const resultados = {
          a_radicar: extrajudiciales?.length,
          sin_radicar: sin_radicar?.length,
          archivados: apremios?.length,
          sin_archivar: activos?.length,
          restantes: apremios?.length,
          faltantes: sin_movimientos?.length,
        };

        const porcentajes = {
          a_radicar: fixNumber((sin_radicar.length * 100) / extrajudiciales.length),
          archivados: fixNumber((activos.length * 100) / apremios.length),
          faltantes: fixNumber((sin_movimientos.length * 100) / apremios.length),
        };

        //Realizar Evaluacion
        const a_radicar = porcentajes.a_radicar <= +permitidosData.sin_radicar;
        const archivados = porcentajes.archivados <= +permitidosData.sin_archivar;
        const faltantes = porcentajes.faltantes <= +permitidosData.faltantes;

        await evaluacionesService.create({
          abogado,
          maximoSinRadicar: permitidosData.sin_radicar,
          maximoSinArchivar: permitidosData.sin_archivar,
          maximoFaltantes: permitidosData.faltantes,
          actuaciones: actuacionesData.map(e => e?.id_etapa ? e : e.historico),
          resultado: a_radicar && archivados && faltantes ? "Aprobado" : "Desaprobado",
          cantidadJuicios: JSON.stringify(actuaciones),
          cantidadTotal: JSON.stringify(resultados),
        });
      }
      setLoading(false);
    }
    catch (err) {
      console.log(err);
      setCompletados(0);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const result = [];
    for (let abogado of abogados.filter(e => !e.baja)) {
      const res = await RealizarEvaluacion(abogado.codexterno);

      setCompletados(prev => prev + 1);
      result.push(res);
    }
  };

  return (
    <div style={{ width: "80%" }} className="eval-config">
      <div className="p-3" >
        <div className="my-4" style={{ width: "80%" }}>
          <Form onSubmit={handleSubmit}>
            <div className="my-3">
              <Form.Label>Fecha de inicio para la evaluación</Form.Label>
              <Form.Control name="fecha_ini_eval" className="my-2" type="date" value={fechas.fecha_ini_eval || ""} onChange={(e) => setFechas({ ...fechas, [e.target.name]: e.target.value })} required />
            </div>
            <div className="my-3">
              <Form.Label>Fecha final para la evaluación</Form.Label>
              <Form.Control name="fecha_fin_eval" className="my-2" type="date" value={fechas.fecha_fin_eval || ""} onChange={(e) => setFechas({ ...fechas, [e.target.name]: e.target.value })} required />
            </div>
            <div>
              <Button className="custom-button" type="submit" style={{ maxWidth: 190 }} >Realizar evaluaciones</Button>
            </div>
          </Form>
        </div>
      </div>

      {loading && (
        <Modal show={loading} backdrop="static" animation={false} centered>
          <Modal.Body className='mt-5'>
            <div className='d-flex flex-column justify-content-center align-items-center'>
              <Spinner animation="border" style={{ color: "#0477AD", width: 50, height: 50 }} />
              <h2 className='mt-3 mb-5'>Cargando...</h2>
            </div>
            <div className="d-flex align-items-center justify-content-center mb-3">
              <b style={{ fontSize: 18 }}>Evaluaciones realizadas {compleados}/{abogados?.filter(e => !e.baja).length}</b>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};